import { createUserNewsletterModel } from "@/forms/form-types/user-model";
import { normalizeFields } from "@/forms/helpers";

export const model = normalizeFields(createUserNewsletterModel(true));
